import { Link, useSearchParams } from "react-router-dom";
import { Check, Copy, Download } from "lucide-react";
import { toast } from "sonner";

export default function OrderConfirmed() {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";

  const copyOrderId = async () => {
    if (!ref) return;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(ref);
      } else {
        const input = document.createElement("textarea");
        input.value = ref;
        input.style.position = "fixed";
        input.style.opacity = "0";
        document.body.appendChild(input);
        input.focus();
        input.select();
        document.execCommand("copy");
        input.remove();
      }
      toast.success("Order ID copied", { description: ref });
    } catch {
      toast.error("Could not copy the order ID. Please select it manually.");
    }
  };

  const saveOrderId = () => {
    if (!ref) return;
    const blob = new Blob([`BARIQUE Order ID\n\n${ref}\n`], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `BARIQUE-Order-${ref}.txt`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Order ID saved");
  };

  return (
    <div className="pt-32 pb-24 bg-ivory min-h-[80vh]" data-testid="order-confirmed">
      <div className="container-lux max-w-2xl text-center">
        <div className="mx-auto w-14 h-14 rounded-full bg-ink text-ivory flex items-center justify-center">
          <Check size={22} strokeWidth={1.25} />
        </div>
        <p className="overline mt-8 text-muted-foreground">Thank you</p>
        <h1 className="mt-4 font-serif tracking-tighter text-4xl md:text-6xl font-light">
          Your order is placed
        </h1>
        {ref && (
          <>
            <p className="mt-6 text-sm text-muted-foreground">
              Reference · <span className="font-mono text-ink" data-testid="order-ref">{ref}</span>
            </p>
            <div className="mt-5 flex justify-center gap-3 flex-wrap">
              <button type="button" onClick={copyOrderId} className="lux-btn-outline py-3 px-5 text-[10px] inline-flex items-center gap-2" data-testid="copy-order-id">
                <Copy size={13} strokeWidth={1.5} /> Copy Order ID
              </button>
              <button type="button" onClick={saveOrderId} className="lux-btn-outline py-3 px-5 text-[10px] inline-flex items-center gap-2" data-testid="save-order-id">
                <Download size={13} strokeWidth={1.5} /> Save Order ID
              </button>
            </div>
          </>
        )}
        <p className="mt-6 text-sm text-muted-foreground max-w-md mx-auto">
          A confirmation email is on the way. Our atelier will reach out over WhatsApp for measurements and delivery timelines.
        </p>
        <div className="divider-thin my-10" />
        <div className="flex justify-center gap-3 flex-wrap">
          <Link to="/collections" className="lux-btn-dark py-3 px-6 text-[10px]">Continue Shopping</Link>
          <Link to={`/track?ref=${ref}`} className="lux-btn-outline py-3 px-6 text-[10px]">Track This Order</Link>
          <Link to="/signup?next=/account" className="lux-btn-outline py-3 px-6 text-[10px]">Create Account To Track</Link>
        </div>
      </div>
    </div>
  );
}
